module.exports = __webpack_public_path__ + "static/media/skill-hat.410760e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Certificate/skill-hat.svg
// module id = 131
// module chunks = 0